import SideModal from '@components/V3/SideModal'
import CartContent from '@page-components/Order/CartV3/CartContent'

interface Props {
  open: boolean
  onClose: () => void
}

export default function ContentWrapper(props: Props) {
  const {open, onClose} = props

  return (
    <SideModal title="Tu carrito" open={open} onClose={onClose}>
      <CartContent />
    </SideModal>
  )
}
